import React from 'react';
import { StyleSheet, View } from 'react-native';
import ImageCache from "../ImageCache";
import Constants from "../../@/Constants";
import * as R from 'unitx/ramda';
import wrapComponent from "../../core/wrapComponent";
const DEFAULTS = {
  onFinish: () => null,
  onError: () => null,
  startAsync: async () => new Promise(() => null)
};

function AppLoadingElement({
  image,
  onFinish = DEFAULTS.onFinish,
  onError = DEFAULTS.onError,
  startAsync = DEFAULTS.startAsync
}) {
  const onLoad = React.useCallback(() => R.pipe(startAsync, R.otherwise(R.pipe(onError, R.identity)), R.andThen(R.when(R.isNotError, onFinish)))().then(), []);
  return /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(ImageCache, {
    style: styles.image,
    source: image !== null && image !== void 0 ? image : {
      uri: Constants.defaultImageURI
    },
    onLoad: onLoad
  }));
}

export default wrapComponent(AppLoadingElement, {});
const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%'
  },
  image: {
    width: '100%',
    height: '100%'
  }
});